import httpClient from './httpClient';

const conceptosAfectosTareosService = {
  // Obtener todos los conceptos configurados como afectos a tareos para una empresa
  obtenerConceptosAfectos: async (empresaId) => {
    try {
      const response = await httpClient.get(`/conceptos-afectos-tareos/empresa/${empresaId}`);
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al obtener conceptos afectos a tareos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener conceptos afectos a tareos',
        data: []
      };
    }
  },

  // Obtener todos los conceptos PLAME de ingresos disponibles
  obtenerConceptosIngresosDisponibles: async () => {
    try {
      const response = await httpClient.get('/conceptos-afectos-tareos/conceptos-ingresos');
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Error al obtener conceptos de ingresos disponibles:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener conceptos de ingresos',
        data: []
      };
    }
  },

  // Configurar qué conceptos están afectos a tareos para una empresa
  configurarConceptosAfectos: async (empresaId, conceptosIds) => {
    try {
      const response = await httpClient.post('/conceptos-afectos-tareos/configurar', {
        empresa_id: empresaId,
        conceptos_plame_ids: conceptosIds
      });
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Configuración guardada exitosamente'
      };
    } catch (error) {
      console.error('Error al configurar conceptos afectos a tareos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al guardar configuración',
        errors: error.response?.data?.errors
      };
    }
  },

  // Agregar un concepto específico como afecto a tareos
  agregarConceptoAfecto: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.post('/conceptos-afectos-tareos', {
        id_empresa: empresaId,
        id_concepto_plame: conceptoPlameId
      });
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || 'Concepto agregado exitosamente'
      };
    } catch (error) {
      console.error('Error al agregar concepto afecto a tareos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al agregar concepto',
        errors: error.response?.data?.errors
      };
    }
  },

  // Remover un concepto de los afectos a tareos
  removerConceptoAfecto: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.delete(`/conceptos-afectos-tareos/empresa/${empresaId}/concepto/${conceptoPlameId}`);
      return {
        success: true,
        message: response.data.message || 'Concepto removido exitosamente'
      };
    } catch (error) {
      console.error('Error al remover concepto afecto a tareos:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al remover concepto'
      };
    }
  },

  // Verificar si un concepto está afecto a tareos para una empresa
  verificarConceptoAfecto: async (empresaId, conceptoPlameId) => {
    try {
      const response = await httpClient.get(`/conceptos-afectos-tareos/verificar/${empresaId}/${conceptoPlameId}`);
      return {
        success: true,
        data: response.data.data || response.data,
        esAfecto: response.data.es_afecto || false
      };
    } catch (error) {
      console.error('Error al verificar concepto afecto:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Error al verificar concepto',
        esAfecto: false
      };
    }
  }
};

export default conceptosAfectosTareosService; 